module.exports = __webpack_public_path__ + "img/logs-w.95284a58.png";